import React, { useState } from 'react';
import {
  Modal,
  Box,
  Button,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  Chip,
} from '@mui/material';
import { UserProfile } from 'src/interfaces/user';
import { useToast } from 'src/hooks/useToast';

interface InviteUserModalProps {
  open: boolean;
  rolesObject: Record<string, any>;
  handleClose: () => void;
  selectedUser: UserProfile;
  onInvite: (data: { email: string; roles: string[] }) => void;
}

const InviteUserModal: React.FC<InviteUserModalProps> = ({
  selectedUser,
  open,
  handleClose,
  rolesObject,
  onInvite,
}) => {
  const [email, setEmail] = useState<string>(selectedUser?.email ?? '');
  const [roles, setRoles] = useState<string[]>([]);
  const { showSuccess, showError, showWarning } = useToast();
  const availableRoles =
    Object.keys(rolesObject).filter(
      (key) => rolesObject[key].type === 'external',
    ) || []; // Example roles

  const handleInvite = () => {
    // Handle user invitation logic here
    console.log(`Inviting ${email} with role ${roles}`);
    const lowerEmail = email.toLowerCase();
    const alpha = lowerEmail.match(/@swyft|@zoomsystems/)
    if (alpha !== null) {
      showWarning(`To invite an internal user, please use the Admin tab.`);
    }
    else {
      return    onInvite({email, roles,})
        .then(() => {
          // this.props.reloadData();
          showSuccess( `An email with invitation has been succesfully sent to ${lowerEmail}`);
          handleClose();
        })
        .catch(() => {
          showError(`Something went wrong! Please contact administrator`);
          handleClose();
        });
    } 
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)', // Center the modal
          width: 400,
          bgcolor: 'background.paper',
          borderRadius: 2,
          boxShadow: 24,
          p: 4,
        }}
      >
        <Typography variant="h6" component="h2" gutterBottom>
          Invite User
        </Typography>
        <TextField
          label="Email"
          variant="outlined"
          fullWidth
          margin="normal"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <FormControl fullWidth margin="normal">
          <InputLabel>User role(s)</InputLabel>
          <Select
            multiple
            value={roles}
            onChange={(e) => setRoles(e.target.value as string[])}
            renderValue={(selected) => (
              <Box className="flex flex-wrap gap-1">
                {selected &&
                  selected.map((role) => (
                    <Chip
                      key={role}
                      label={rolesObject[role].name}
                      className="bg-orange-500 text-white"
                    />
                  ))}
              </Box>
            )}
            displayEmpty
          >
            <MenuItem value="">
              <em>Select...</em>
            </MenuItem>
            {availableRoles.map((roleOption, index) => (
              <MenuItem key={index} value={roleOption}>
                {rolesObject[roleOption].name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <Button
          variant="contained"
          color="primary"
          onClick={handleInvite}
          fullWidth
        >
          Invite
        </Button>
      </Box>
    </Modal>
  );
};

export default InviteUserModal;
